module.exports = __webpack_public_path__ + "static/img/02_04.3208a15a.jpg";